function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "New-Icon/Delete",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Safespace",
  x: 0,
  y: 0,
  width: 20,
  height: 20
}), /*#__PURE__*/React.createElement("g", {
  id: "usun",
  transform: "translate(2.5, 0.5)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.58,2.65 L11.11,2.65 L11.11,1.22 C11.0834054,0.896405366 10.8042231,0.652674723 10.48,0.67 L5.84,0.67 C5.51577694,0.652674723 5.23659457,0.896405366 5.21,1.22 L5.21,2.65 L1.74,2.65 C1.41200249,2.62700249 1.12659498,2.87227457 1.1,3.2 L1.1,5.26 C1.13169607,5.58372035 1.41556241,5.82323257 1.74,5.8 L1.93,5.8 L2.51,16.88 C2.54664986,17.194191 2.82455846,17.4235759 3.14,17.4 L13.14,17.4 C13.452193,17.4136213 13.7241919,17.1891142 13.77,16.88 L14.39,5.8 L14.58,5.8 C14.9024824,5.82301316 15.1834216,5.58220818 15.21,5.26 L15.21,3.2 C15.1834054,2.87640537 14.9042231,2.63267472 14.58,2.65 Z",
  id: "Path",
  fill: "#48A9A1",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.68,3.31 L10.21,3.31 L10.21,1.88 C10.183405,1.55227457 9.89799751,1.30700249 9.57,1.33 L4.94,1.33 C4.61200249,1.30700249 4.32659498,1.55227457 4.3,1.88 L4.3,3.31 L0.83,3.31 C0.505776939,3.29267472 0.226594567,3.53640537 0.2,3.86 L0.2,5.92 C0.226578423,6.24220818 0.507517573,6.48301316 0.83,6.46 L1,6.46 L1.58,17.54 C1.61664986,17.854191 1.89455846,18.0835759 2.21,18.06 L12.21,18.06 C12.5259293,18.078945 12.8038713,17.8531172 12.85,17.54 L13.42,6.46 L13.62,6.46 C13.9424824,6.48301316 14.2234216,6.24220818 14.25,5.92 L14.25,3.86 C14.2251994,3.55948186 13.981212,3.32405538 13.68,3.31 Z M5.57,2.42 L8.94,2.42 L8.94,3.31 L5.57,3.31 L5.57,2.42 Z M11.67,17 L2.84,17 L2.29,6.46 L12.22,6.46 L11.67,17 Z M13,5.37 L1.47,5.37 L1.47,4.37 L13,4.37 L13,5.37 Z",
  id: "Shape",
  fill: "#565250"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.71,15.64 C5.03422306,15.6573253 5.31340543,15.4135946 5.34,15.09 L5.34,8.34 C5.31340543,8.01640537 5.03422306,7.77267472 4.71,7.79 C4.38200249,7.76700249 4.09659498,8.01227457 4.07,8.34 L4.07,15.09 C4.09659498,15.4177254 4.38200249,15.6629975 4.71,15.64 L4.71,15.64 Z",
  id: "Path",
  fill: "#48A9A1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.26,15.64 C7.58422306,15.6573253 7.86340543,15.4135946 7.89,15.09 L7.89,8.34 C7.84975512,8.0199305 7.57758974,7.7798436 7.255,7.7798436 C6.93241026,7.7798436 6.66024488,8.0199305 6.62,8.34 L6.62,15.09 C6.64659498,15.4177254 6.93200249,15.6629975 7.26,15.64 L7.26,15.64 Z",
  id: "Path",
  fill: "#48A9A1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.8,15.64 C10.1279975,15.6629975 10.413405,15.4177254 10.44,15.09 L10.44,8.34 C10.413405,8.01227457 10.1279975,7.76700249 9.8,7.79 C9.47577694,7.77267472 9.19659457,8.01640537 9.17,8.34 L9.17,15.09 C9.19659457,15.4135946 9.47577694,15.6573253 9.8,15.64 L9.8,15.64 Z",
  id: "Path",
  fill: "#48A9A1"
})));

var SvgDelete = function SvgDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Delete.844c3bf0.svg";
export { ForwardRef as ReactComponent };